/* eslint-disable */

import A11yDialog from 'a11y-dialog';

/**
 * Nur für das Backend.
 * Initialisierung der Form-Collection zum dynamischen Hinzufügen und Entfernen
 */
class BackendFormCollection {
    constructor($collectionHolder) {
        this.$collectionHolder = $collectionHolder;

        const label = $collectionHolder.data('add-new-label');
        const $addEntryButton = $('<button type="button" class="add_tag_link">' + label + '</button>');
        const $newLinkLi = $('<li></li>').append($addEntryButton);

        $collectionHolder.append($newLinkLi);
        $collectionHolder.data('index', $collectionHolder.find(':input').length);
        self = this;
        $addEntryButton.on('click', () => {
            // add a new tag form (see next code block)
            self.addEntryForm($collectionHolder, $newLinkLi);
        });

        $collectionHolder.find('li').each(function () {
            self.addEntryFormDeleteLink($(this));
        });
    }

    addEntryForm($collectionHolder, $newLinkLi) {
        // Get the data-prototype explained earlier
        const prototype = $collectionHolder.data('prototype');

        // get the new index
        const index = $collectionHolder.data('index');

        let newForm = prototype;
        // You need this only if you didn't set 'label' => false in your tags field in TaskType
        // Replace '__name__label__' in the prototype's HTML to
        // instead be a number based on how many items we have
        // newForm = newForm.replace(/__name__label__/g, index);

        // Replace '__name__' in the prototype's HTML to
        // instead be a number based on how many items we have
        newForm = newForm.replace(/__name__/g, index);

        // increase the index with one for the next item
        $collectionHolder.data('index', index + 1);

        // Display the form in the page in an li, before the "Add a tag" link li
        const $newFormLi = $('<li></li>').append(newForm);
        $newLinkLi.before($newFormLi);
        this.addEntryFormDeleteLink($newFormLi);
    }

    addEntryFormDeleteLink($entryFormLi) {
        const $removeFormButton = $('<button type="button">Delete this entry</button>');
        $entryFormLi.append($removeFormButton);

        $removeFormButton.on('click', () => {
            // remove the li for the tag form
            $entryFormLi.remove();
        });
    }
}

const backendFormCollections = {
    init(selector) {
        $(selector).each(function () {
            new BackendFormCollection($(this));
        });
    },
};

export default backendFormCollections;
